var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.60016V11.4002C10.6667 13.7335 9.73337 14.6668 7.40004 14.6668H4.60004C2.26671 14.6668 1.33337 13.7335 1.33337 11.4002V8.60016C1.33337 6.26683 2.26671 5.3335 4.60004 5.3335H7.40004C9.73337 5.3335 10.6667 6.26683 10.6667 8.60016Z",
    fill: "#FF8A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.3999 1.3335H8.59986C6.29984 1.3335 5.36651 2.24683 5.33984 4.50016H7.39986C10.1999 4.50016 11.4999 5.80016 11.4999 8.60016V10.6602C13.7532 10.6335 14.6665 9.70016 14.6665 7.40016V4.60016C14.6665 2.26683 13.7332 1.3335 11.3999 1.3335Z",
    fill: "#FF8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ab0ce7ac11c68af86dc30631746290f8.svg";
export { ForwardRef as ReactComponent };